export const environment = {
  production: true,
  apiBase: "https://apiunify.academia.cl",
  // apiBase:'https://apiunify.academia.cl'
  xApiKey: "rx6pmATw.mygbeusaXXGdC65IQcqGIKbETijKMrT5",
};
